import { ExecutionStatus } from '@scale/shared/types/execution';
import { IQueryExecution } from '@scale/shared/types/query';

const QueryResult = (props: { result: IQueryExecution }) => {
  const { result } = props;

  return (
    <>
      {result.status === ExecutionStatus.Running || result.error ? (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {result.status === ExecutionStatus.Running ? (
            <p>Query is still running</p>
          ) : (
            <p>{result.error?.message}</p>
          )}
        </div>
      ) : (
        <table
          style={{
            width: '100%',
          }}
        >
          <thead>
            <tr>
              {Object.keys(result.query.outputTypes).map(key => {
                return (
                  <th style={{ padding: '0 .5rem' }} key={'header-' + key}>
                    {key}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {result.output &&
              result.output.map((row, rowIndex) => (
                <tr key={'row-' + rowIndex}>
                  {Object.keys(result.query.outputTypes).map(key => {
                    return (
                      <td
                        key={'row-' + rowIndex + '-' + key}
                        style={{ padding: '.5rem' }}
                      >{`${row[key]}`}</td>
                    );
                  })}
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default QueryResult;
